import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import '../../Asset/Css/util.css';
import '../../Asset/Css/main.css';
import { Link } from 'react-router-dom';
import global from '../global';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
const { SearchBar } = Search;

export class AdminNotification extends Component {
    state = {
        notification: [],
        RemitterCode: '',
        URL: config.url.API_URL,
        columns: [{
            dataField: 'AssignmentCode',
            text: 'Assignment Code',
            hidden: true
        },
            {
                dataField: 'AssignmentName',
                text: 'Assignment',
                headerAlign: 'center'

            },
            {
                dataField: 'RemitterName',
                text: 'Remitter',
                headerAlign: 'center',
                sort: true,

            },
            {
                dataField: 'FinancialYear',
                text: 'Financial Year',
                headerAlign: 'center',
                align: 'center',
                sort: true,
            },
            {
                dataField: 'DeclarationCount',
                text: 'Declaration Count',
                headerAlign: 'center',
                align: 'center',
                sort: true,
            },
        {
            dataField: "Action",
            text: "Action",
            formatter: (rowContent, row) => {
                return (
                    <div>
                        <button className="btn btn-success p-10" style={{ display: 'none' }}
                            onClick={e => {
                                e.persist();
                                AdminNotification.handleApprove(row.AssignmentCode)
                            }}> </button>

                        <button className="btn btn-primary p-10 m-l-10"
                            onClick={e => {
                                e.persist();
                                AdminNotification.handleDownload(row.AssignmentCode)
                            }}> <FontAwesomeIcon icon="cloud-download-alt" /> </button>
                    </div>
                )
            }
        }
        ]
    }

    static handleApprove(id) {
        //axios.post(global.Notification., demoAssignment,
        //    { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
        //    .then(json => {
        //        console.log(json.data.status);
        //        if (json.data.status) {

        //        }
        //        else {
        //            this.NotificationAlert('error', json.data.message);
        //        }
        //    })
        //    .catch(error => {
        //        console.log(error);
        //   });
    }

    static handleDownload(rowContent) {
        axios.get(global.Form15GH.DownloadBulkDetailsAPI + rowContent,
            {
                headers: { "Authorization": `Bearer ${localStorage.getItem('token')}`, 'Accept': 'application/zip' },
                responseType: 'blob'
            })
            .then(response => {
                console.log(response);
                const content = response.headers['content-type'];
                const fileName = "Shareholder Details_" + moment().format("DD/MM/YYYY") + ".zip"
                download(response.data, fileName, content)
            })
            .catch(error => {
                console.log(error);
            });
    }

    componentDidMount() {

        //axios.get(global.UserManagement.GetSessionDetailsAPI)
        //    .then(response => {
        //        if (response.data.Status) {
        //            this.setState({
        //                RemitterCode: response.data.RemitterCode,
        //                url: config.url.Web_URL + '/' + response.data.RemitterCode
        //            });
        //        } else {
        //            window.location.href = config.url.Web_URL + `/Error/404`;
        //            return;
        //        }
        //    })
        //    .catch(error => {
        //        console.log(error);
        //    });

        axios.get(global.Notification.GetNotificationAPI,
            { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } },
            { responseType: 'json' })
            .then(response => {
                if (response.status) {
                    this.setState({
                        notification: response.data.data
                    });
                }
                else {
                    this.setState({
                        notification: []
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        const options = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            firstPageText: 'First',
            prePageText: 'Back',
            nextPageText: 'Next',
            lastPageText: 'Last',
            nextPageTitle: 'First page',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Next page',
            lastPageTitle: 'Last page',
            showTotal: true,
            totalSize: this.state.notification.length
        };

        const contentTable = ({ paginationProps, paginationTableProps }) => (
            <div>
                <ToolkitProvider
                    keyField="AssignmentCode"
                    columns={this.state.columns}
                    data={this.state.notification}
                    search
                >
                    {
                        toolkitprops => (
                            <div>
                                <SearchBar {...toolkitprops.searchProps} />
                                <BootstrapTable
                                    striped
                                    hover
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
                <PaginationListStandalone {...paginationProps} />
            </div>
        );
        let content = Layout.RenderNavMenu()

        return (
            <div>
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><a href={this.state.URL + "/Nexdigm/Dashboard"} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                        <li><a className="text-white">Report</a></li>
                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title">Report</h4>

                            <PaginationProvider
                                pagination={
                                    paginationFactory(options)
                                }
                            >
                                {contentTable}
                            </PaginationProvider>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
